import { Module } from "@nestjs/common";
import { AssetRequistion } from "./entity/asset-requisition.entity";
import { AssetRequistionRepository } from "./repository/asset-requisition.repository";
import { TypeOrmModule } from "@nestjs/typeorm";
import { AssetRequestController } from "./asset-requistion.controller";
import { AssetRequestService } from "./asset-requistion.service";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { AssetRequistionAdapter } from "./asset-requistion.adapter";
import { Assets } from "../open-assets/open-assets-entity";


@Module({
    imports : [
        TypeOrmModule.forFeature([AssetRequistion,AssetRequistionRepository,Assets]),
    ],
    controllers : [AssetRequestController],
    providers : [AssetRequestService,AssetRequistionAdapter,ApplicationExceptionHandler],
    exports: [AssetRequestService]
})

export class AssetRequestModule {}